module.exports = __webpack_public_path__ + "./img/variant-specification.svg";